<style>
.contato-container {
    border: 2px solid #666;
    border-radius: 5px;
    margin-bottom: 15px;
    background: #EEE;
    cursor: pointer;
    font-weight: bold;
    font-size: 13pt;
}

.contato-container:hover {
    border: 2px solid #002B82;
}

.contato-container.selected {
    background: #FFF;
    border: 2px solid #00822B;
}

.phone-container {
    max-width: 200px;
}

.modo-container {
    border: 2px solid #666;
    border-radius: 5px;
    margin-bottom: 15px;
    background: #EEE;
    cursor: pointer;
}

.modo-container:hover {
    border: 2px solid #002B82;
}

.pointer {
    cursor: pointer;
}

.declaration-cb {
    height: 22px;
    width: 22px;
    border-radius: 25px !important;
    border: 2px solid #000 !important;
}

.declaration-table td {
    font-size: 11pt;
}

.declaration-table td:first-child {
    text-align: right;
    vertical-align: middle;
    padding-top: 8px;
}

.declaration-table td:last-child {
    text-align: center;
    vertical-align: middle;
}

.green-text {
    color: #118111
}


.cbx {
    -webkit-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
}

.cbx span {
    display: inline-block;
    vertical-align: middle;
    transform: translate3d(0, 0, 0);
}

.cbx span:first-child {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transform: scale(1);
    vertical-align: middle;
    border: 1px solid #B9B8C3;
    transition: all 0.2s ease;
}

.cbx span:first-child svg {
    position: absolute;
    z-index: 1;
    top: 8px;
    left: 6px;
    fill: none;
    stroke: white;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16px;
    stroke-dashoffset: 16px;
    transition: all 0.3s ease;
    transition-delay: 0.1s;
    transform: translate3d(0, 0, 0);
}

.cbx span:first-child:before {
    content: "";
    width: 100%;
    height: 100%;
    background: #28d428;
    display: block;
    transform: scale(0);
    opacity: 1;
    border-radius: 50%;
    transition-delay: 0.2s;
}

.cbx span:last-child {
    margin-left: 8px;
}

.cbx:hover span:first-child {
    border-color: #00BA00;
}

.inp-cbx:checked+.cbx span:first-child {
    border-color: #00BA00;
    background: #00BA00;
    animation: check 0.6s ease;
}

.inp-cbx:checked+.cbx span:first-child svg {
    stroke-dashoffset: 0;
}

.inp-cbx:checked+.cbx span:first-child:before {
    transform: scale(2.2);
    opacity: 0;
    transition: all 0.6s ease;
}

.inp-cbx:checked+.cbx span:last-child {
    color: #B9B8C3;
    transition: all 0.3s ease;
}

.inp-cbx:checked+.cbx span:last-child:after {
    transform: scaleX(1);
    transition: all 0.3s ease;
}

@keyframes check {
    50% {
        transform: scale(1.2);
    }
}
</style>
<template>
    <div class="card card-plain"
        style="margin: 0 auto; max-width: 450px; background: #FFF; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);">
        <div class="pb-0 card-header text-start">
            <h4 class="font-weight-bolder">Verificação de identidade</h4>

            <p v-if="meiosContatoCarregados && (
                !meiosContato ||
                (
                    (!meiosContato.emails ||
                        meiosContato.emails.length == 0)
                    &&
                    (!meiosContato.phones ||
                        meiosContato.phones.length == 0)
                )
            )">
                <span class="text-danger" style="text-align: justify !important; font-weight: bold;">
                    Você não possui meios de verificação cadastrados com a Telemidia. Por favor, entre em contato.
                </span>
            </p>
            <p v-else class="mb-0" style="line-height: 1.3">
                <span v-if="!modoSelecionado">
                    Selecione abaixo o meio de verificação desejado:
                </span>
                <span v-if="modoSelecionado == 'whatsapp'">
                    Selecione o número de WhatsApp em que deseja receber o código de verificação:
                </span>
                <span v-if="modoSelecionado == 'sms'">
                    Selecione o número de celular em que deseja receber o código de verificação via SMS:
                </span>
                <span v-if="modoSelecionado == 'email'">
                    Selecione o endereço de e-mail em que deseja receber o código de verificação:
                </span>
            </p>

        </div>

        <div class="card-body">
            <div v-if="loadingMeiosContato">
                <div class="spinner-border text-primary" role="status"></div>
                <br>
                Buscando meios de verificação...
            </div>

            <div v-if="!modoSelecionado && !loadingMeiosContato">
                <div v-if="meiosContato?.phones?.length > 0" @click="selecionarModo('whatsapp')"
                    class="modo-container p-1" :class="modoSelecionado == 'whatsapp' ? 'selected' : ''">

                    <table style="width: 100%;">
                        <tr>
                            <td class="text-center" style="font-size: 16pt; width: 60px;">
                                <font-awesome-icon icon="fa-brands fa-whatsapp" />
                            </td>
                            <td class="text-center">
                                <b>WhatsApp</b>
                            </td>
                            <td class="text-center" style="width: 60px;">
                                <font-awesome-icon icon="fa-solid fa-chevron-right" />
                            </td>
                        </tr>
                    </table>

                    <!-- <table>
                    <tr v-for="numero in meiosContato.phones" v-bind:key="numero.encrypted">
                        <td>
                            <label>
                                <input type="checkbox" />
                                <span>{{ formatarTelefone(numero.masked) }}</span>
                            </label>
                        </td>
                    </tr>
                </table> -->

                </div>

                <div v-if="meiosContato?.phones?.length > 0" @click="selecionarModo('sms')" class="modo-container p-1"
                    :class="modoSelecionado == 'sms' ? 'selected' : ''">

                    <table style="width: 100%;">
                        <tr>
                            <td class="text-center" style="font-size: 16pt; width: 60px;">
                                <font-awesome-icon icon="fa-solid fa-comment" />
                            </td>
                            <td class="text-center">
                                <b>SMS</b>
                            </td>
                            <td class="text-center" style="width: 60px;">
                                <font-awesome-icon icon="fa-solid fa-chevron-right" />
                            </td>
                        </tr>
                    </table>

                </div>

                <div v-if="meiosContato?.emails?.length > 0" @click="selecionarModo('email')" class="modo-container p-1"
                    :class="modoSelecionado == 'email' ? 'selected' : ''">

                    <table style="width: 100%;">
                        <tr>
                            <td class="text-center" style="font-size: 16pt; width: 60px;">
                                <font-awesome-icon icon="fa-solid fa-envelope" />
                            </td>
                            <td class="text-center">
                                <b>E-mail</b>
                            </td>
                            <td class="text-center" style="width: 60px;">
                                <font-awesome-icon icon="fa-solid fa-chevron-right" />
                            </td>
                        </tr>
                    </table>

                </div>
            </div>

            <div v-if="modoSelecionado">
                <div v-if="modoSelecionado == 'whatsapp' || modoSelecionado == 'sms'">
                    <div v-for="phone in meiosContato.phones" v-bind:key="phone.encrypted"
                        class="contato-container phone-container"
                        :class="(contatoSelecionado.type == 'phone' && contatoSelecionado.encrypted == phone.encrypted) ? 'selected' : ''"
                        @click="selectContato('phone', phone.encrypted)">
                        {{ formatarTelefone(phone.masked) }}
                    </div>
                </div>

                <div v-if="modoSelecionado == 'email'">
                    <div v-for="email in meiosContato.emails" v-bind:key="email.encrypted"
                        class="contato-container email-container"
                        :class="(contatoSelecionado.type == 'email' && contatoSelecionado.encrypted == email.encrypted) ? 'selected' : ''"
                        @click="selectContato('email', email.encrypted)">
                        {{ email.masked }}
                    </div>
                </div>

                <div class="p-0 m-0">
                    <button class="btn btn-sm btn-primary px-3 m-0 mt-1"
                        :disabled="!contatoSelecionado.encrypted || sendingCode" @click="enviarCodigo">
                        <font-awesome-icon :icon="getSendButtonIcon" class="me-2"
                            style="font-size: 11pt; margin-bottom: -1px;" />
                        <span v-if="!sendingCode">ENVIAR CÓDIGO</span>
                        <span v-else>ENVIANDO...</span>
                    </button>
                </div>
            </div>

            <div class="horizontal-divider mt-3 mb-0"></div>
        </div>

        <div class="px-1 pt-0 text-center card-footer px-lg-2">
            <p class="mx-auto mb-4 text-sm">
                Dúvidas?
                <a href="https://api.whatsapp.com/send?phone=553537311118" target="_blank"
                    class="text-warning text-gradient font-weight-bold">Entre em contato pelo WhatsApp</a>
            </p>
            <button class="btn btn-light btn-sm" @click="voltar">VOLTAR</button>
        </div>
    </div>
</template>
<script>
// import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
import api from "../services/api.js";
import { formatarTelefone, errorMessage } from '../helpers/helper.js'
import { getUser } from '../helpers/jwt.js'

let modoSelecionado = null

let meiosContato = {
    emails: [],
    phones: [],
}

let contatoSelecionado = {
    type: null,
    encrypted: null,
}

let user = {}

let loadingMeiosContato = false
let sendingCode = false
let meiosContatoCarregados = false

export default {
    name: "Verificacao",
    components: {
        // ArgonButton
    },
    data() {
        return {
            contatoSelecionado,
            meiosContato,
            modoSelecionado,
            user,
            loadingMeiosContato,
            sendingCode,
            meiosContatoCarregados,
        }
    },
    beforeMount() {
        this.user = getUser()
    },
    async created() {
        this.loadingMeiosContato = true
        this.meiosContato = await api.getMeiosContato(this.user.cpfCnpj)
        this.loadingMeiosContato = false
        this.meiosContatoCarregados = true

        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
    computed: {
        getSendButtonIcon() {
            let icon = null
            switch (this.modoSelecionado) {
                case 'whatsapp':
                    icon = 'fa-brands fa-whatsapp'
                    break
                case 'sms':
                    icon = 'fa-solid fa-comment'
                    break
                case 'email':
                    icon = 'fa-solid fa-envelope'
                    break
            }
            return icon
        }
    },
    methods: {
        async enviarCodigo() {
            const modo = this.modoSelecionado
            const encryptedContato = this.contatoSelecionado.encrypted

            this.sendingCode = true
            const envio = await api.enviarCodigoVerificacao(modo, encryptedContato)
            this.sendingCode = false
            if (!envio) {
                errorMessage(this, 'Ocorreu um erro ao enviar o código de verificação.')
                return false
            }

            this.$router.push({ name: 'ConfirmarCodigo' })
        },

        selectContato(type, encrypted) {
            this.contatoSelecionado = {
                type,
                encrypted,
            }
        },

        formatarTelefone,

        selecionarModo(modo) {
            this.modoSelecionado = modo

            this.contatoSelecionado = {
                type: null,
                encrypted: null,
            }

            switch (this.modoSelecionado) {
                case 'whatsapp':
                case 'sms':
                    if (this.meiosContato.phones.length == 1) {
                        this.contatoSelecionado = {
                            type: 'phone',
                            encrypted: this.meiosContato.phones[0].encrypted,
                        }
                    }
                    break
                case 'email':
                    if (this.meiosContato.emails.length == 1) {
                        this.contatoSelecionado = {
                            type: 'email',
                            encrypted: this.meiosContato.emails[0].encrypted,
                        }
                    }
                    break
            }
        },

        async getMeiosContato() {
            // const meiosContato =   
        },

        voltar() {
            if (this.modoSelecionado)
                this.modoSelecionado = null
            else
                this.$router.push({ name: 'Inicio' })
        },
    }
};
</script>